export default __webpack_public_path__ + "img/41eecf85b5dfb0e26d317ad05b0b7ee2.svg";